export default Object.freeze({
  RUNS: "/migration-validation",
  RUN_DETAIL: "/migration-validation/run",
  TRANSACTION_DETAIL: "/migration-validation/transaction",
});
